export default __webpack_public_path__ + "static/media/wlochy.aa69e763.JPG";